import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { _HttpClient } from '@delon/theme';

@Injectable({ providedIn: 'root' })
export class DocNavService {
  constructor(
    private router: Router,
    private http: _HttpClient
  ) {}

  openDoc(docType: string, docCode: string) {
    return new Promise((resolve, reject) => {
      this.http.post('api/docInfo/FindDocId', { docType, docCode }).subscribe({
        next: res => {
          let url = this.getUrl(docType, res.docId);
          this.router.navigateByUrl(url);
          resolve(true);
        },
        error: () => {
          reject();
        }
      });
    });
  }

  openDocById(docType: string, docId: string) {
    return new Promise((resolve, reject) => {
      let url = this.getUrl(docType, docId);
      this.router.navigateByUrl(url);
      resolve(true);
    });
  }

  getEInvStatus(docType: string, docCode: string) {
    return new Promise<string | null>((resolve, reject) => {
      this.http
        .post('api/docInfo/FindEInvStatus', { docType, docCode })
        .subscribe({
          next: (res: { eInvStatus: string }) => {
            // Check if the EInvStatus exists
            if (res.eInvStatus) {
              resolve(res.eInvStatus); // Resolve the promise with the eInvStatus value
            } else {
              resolve(null); // Resolve with null if eInvStatus is not found
            }
          },
          error: () => {
            reject(); // Reject the promise on error
          }
        });
    });
  }

  private getUrl(docType: string, docId: string) {
    let url = '';
    switch (docType) {
      case 'JV':
        url = `gl/jv/detail/${docId}`;
        break;
      case 'OR':
        url = `gl/rv/detail/${docId}`;
        break;
      case 'PV':
        url = `gl/pv/detail/${docId}`;
        break;
      case 'INV':
        url = `ar/inv/detail/${docId}`;
        break;
      case 'ARCN':
      case 'CN':
        url = `ar/cn/detail/${docId}`;
        break;
      case 'ARDN':
      case 'DN':
        url = `ar/dn/detail/${docId}`;
        break;
      case 'AROR':
        url = `ar/or/detail/${docId}`;
        break;
      case 'BIL':
        url = `ap/bil/detail/${docId}`;
        break;
      case 'APDN':
      case 'CDN':
        url = `ap/dn/detail/${docId}`;
        break;
      case 'APCN':
      case 'CCN':
        url = `ap/cn/detail/${docId}`;
        break;
      case 'APPV':
        url = `ap/pay-bil/detail/${docId}`;
        break;
      case 'SINV':
        url = `sale/inv/detail/${docId}`;
        break;
      case 'SCN':
        url = `sale/cn/detail/${docId}`;
        break;
      case 'SDN':
        url = `sale/dn/detail/${docId}`;
        break;
      case 'PINV':
        url = `purchase/inv/detail/${docId}`;
        break;
      case 'PDN':
        url = `purchase/dn/detail/${docId}`;
        break;
      case 'PCN':
        url = `purchase/cn/detail/${docId}`;
        break;
      case 'CS':
        url = `sale/cs/detail/${docId}`;
        break;
      case 'CSR':
        url = `sale/csr/detail/${docId}`;
        break;
      case 'CP':
        url = `purchase/cp/detail/${docId}`;
        break;
      case 'CPF':
        url = `purchase/cpf/detail/${docId}`;
        break;
      case 'RF':
        url = `ar/refund/detail/${docId}`;
        break;
      case 'CRF':
        url = `ap/refund/detail/${docId}`;
        break;
      case 'CEI':
        url = `einv/einv-consolidate/detail/${docId}`;
        break;
      case 'QT':
        url = `sale/qt/detail/${docId}`;
        break;
      case 'SO':
        url = `sale/so/detail/${docId}`;
        break;
      case 'DO':
        url = `sale/do/detail/${docId}`;
        break;
      case 'PO':
        url = `purchase/po/detail/${docId}`;
        break;
      case 'PR':
        url = `purchase/pr/detail/${docId}`;
        break;
      case 'GRN':
        url = `purchase/grn/detail/${docId}`;
        break;
      case 'SIN':
        url = `stk/in/detail/${docId}`;
        break;
      case 'SOUT':
        url = `stk/out/detail/${docId}`;
        break;
      case 'SADJ':
        url = `stk/adj/detail/${docId}`;
        break;
      case 'STT':
        url = `stk/transfer/detail/${docId}`;
        break;
    }
    return url;
  }
}
